import script from "./OSelecionarTiposDeAtividade.vue?vue&type=script&lang=ts&setup=true"
export * from "./OSelecionarTiposDeAtividade.vue?vue&type=script&lang=ts&setup=true"

import "./OSelecionarTiposDeAtividade.vue?vue&type=style&index=0&id=387f5c74&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-387f5c74"]])

export default __exports__